import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/features/page.tsx");
